












import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/nav-left.vue";
import PatientList from "./patient-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    PatientList,
  },
})
export default class Zlkz extends Vue {}
